export enum TransportState {
  Disconnected,
  Connecting,
  Joined,
  Failed,
  Reconnecting,
  Leaving,
}
